import { useEffect, useState } from 'react';
import { staticComponentValueConverter } from '../StaticComponentValues';

const Timer_1 = ({ item }) => {
  const [timeLeft, setTimeLeft] = useState({});
  const [expired, setExpired] = useState(false);
  const [invalidDate, setInvalidDate] = useState(false);
  const customization = staticComponentValueConverter(item?.customization);

  useEffect(() => {
    if (!customization?.timeSelectionText) return;

    const parseDate = input => {
      const [datePart, timePart] = input.split(' ');
      if (!datePart || !timePart) return null;

      const [day, month, year] = datePart.split('/');
      const [hour, minute] = timePart.split(':');
      if (!day || !month || !year || !hour || !minute) return null;

      const parsedDate = new Date(`${year}-${month}-${day}T${hour}:${minute}:00`);
      return isNaN(parsedDate.getTime()) ? null : parsedDate;
    };

    const endTimeDate = parseDate(customization?.timeSelectionText);

    if (!endTimeDate) {
      setInvalidDate(true);
      setExpired(false);
      return;
    }

    const endTime = endTimeDate.getTime();
    const now = new Date().getTime();

    if (endTime <= now) {
      setInvalidDate(true);
      setExpired(false);
      return;
    }

    setInvalidDate(false);
    setExpired(false);

    const updateCountdown = () => {
      const now = new Date().getTime();
      const distance = endTime - now;

      if (distance <= 0) {
        setExpired(true);
        clearInterval(interval);
        return;
      }

      setTimeLeft({
        days: Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours: Math.floor((distance / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((distance / (1000 * 60)) % 60),
        seconds: Math.floor((distance / 1000) % 60),
      });
    };

    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);
    return () => clearInterval(interval);
  }, [customization?.timeSelectionText]);

  if (!customization?.timeSelectionText)
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: customization?.title !== '' ? '10px' : '0px',
          backgroundColor: customization?.backgroundColor,
          padding: customization?.padding,
          textAlign: customization?.textAlignment,
          fontSize: customization?.textSize,
          fontWeight: customization?.textWeight,
          color: customization?.textColor,
          letterSpacing: customization?.textLetterSpacing,
          fontStyle: customization?.textStyle,
        }}
      >
        Tarih bilgisi eksik
      </div>
    );
  if (invalidDate)
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: customization?.title !== '' ? '10px' : '0px',
          backgroundColor: customization?.backgroundColor,
          padding: customization?.padding,
          textAlign: customization?.textAlignment,
          fontSize: customization?.textSize,
          fontWeight: customization?.textWeight,
          color: customization?.textColor,
          letterSpacing: customization?.textLetterSpacing,
          fontStyle: customization?.textStyle,
        }}
      >
        Tarih geçersiz veya geçmiş bir tarih!
      </div>
    );
  if (expired)
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: customization?.title !== '' ? '10px' : '0px',
          backgroundColor: customization?.backgroundColor,
          padding: customization?.padding,
          textAlign: customization?.textAlignment,
          fontSize: customization?.textSize,
          fontWeight: customization?.textWeight,
          color: customization?.textColor,
          letterSpacing: customization?.textLetterSpacing,
          fontStyle: customization?.textStyle,
        }}
      >
        Süre doldu
      </div>
    );

  const { days, hours, minutes, seconds } = timeLeft;

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: customization?.title !== '' ? '10px' : '0px',
        backgroundColor: customization?.backgroundColor,
        padding: customization?.padding,
      }}
    >
      <div
        style={{
          textAlign: customization?.textAlignment,
          fontSize: customization?.textSize,
          fontWeight: customization?.textWeight,
          color: customization?.textColor,
          letterSpacing: customization?.textLetterSpacing,
          fontStyle: customization?.textStyle,
        }}
      >
        {customization?.text}
      </div>
      <div style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
        {days > 0 && <TimeBox customization={customization} value={days} label="GÜN" />}
        {hours > 0 && <TimeBox customization={customization} value={hours} label="SAAT" />}
        <TimeBox customization={customization} value={minutes} label="DAKİKA" />
        <TimeBox customization={customization} value={seconds} label="SANİYE" />
      </div>
    </div>
  );
};

const TimeBox = ({ value, label, customization }) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      background:
        customization?.isTimerBackgroundColorNotShowOpacity === true
          ? customization?.timerBoxBackgroundColor
          : 'rgba(255, 255, 255, 0.1)',
      padding: '5px 10px',
      borderRadius: '5px',
      textAlign: 'center',
    }}
  >
    <div
      style={{
        color: customization?.timerNumberColor,
        fontSize: customization?.timerNumberSize,
        fontWeight: customization?.timerNumberWeight,
      }}
    >
      {value}
    </div>
    <div
      style={{
        color: customization?.timerTextColor,
        fontSize: customization?.timerTextSize,
        fontWeight: customization?.timerTextWeight,
      }}
    >
      {label}
    </div>
  </div>
);

export default Timer_1;
